import type { ReactNode } from "react";

type FormFieldProps = {
  label: string;
  htmlFor: string;
  helpText?: string;
  errorText?: string;
  required?: boolean;
  children: ReactNode;
};

export function FormField({
  label,
  htmlFor,
  helpText,
  errorText,
  required,
  children,
}: FormFieldProps) {
  return (
    <div className="cf-form-field">
      <label htmlFor={htmlFor} data-required={required ? "true" : undefined}>
        {label}
      </label>
      {children}
      {errorText ? <p className="cf-error">{errorText}</p> : null}
      {!errorText && helpText ? <p className="cf-help">{helpText}</p> : null}
    </div>
  );
}
